import { render, staticRenderFns } from "./AdminOrderFilters.vue?vue&type=template&id=21ed9991"
import script from "./AdminOrderFilters.vue?vue&type=script&lang=js"
export * from "./AdminOrderFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports